import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {
  CardHeader,
  CardContent,
  MenuItem,
} from "@mui/material";

import { useState,useEffect } from "react";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
  IconButton,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Dropdown from 'components/CustomDropdown/Dropdown';


function AddTutor() {

  const [city, setCity] = useState("");

  return (

   <DashboardLayout>
      <DashboardNavbar />
        
        <ArgonBox py={3}>
      <ArgonBox mb={3}>
        <Card
          sx={{
            boxShadow: 6,
            borderRadius: 4,
            overflow: "hidden",
            background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
          }}
        >
          {/* Header */}
          <ArgonBox
            px={3}
            py={2}
            borderBottom="2px solid #f0f0f0"
            sx={{ background: "#fafafa" }}
          >
            <ArgonTypography
              variant="h4"
              fontWeight="bold"
              color="primary"
              textTransform="uppercase"
            >
              🏘️ Edit City
            </ArgonTypography>
            <ArgonTypography variant="body2" color="text.secondary" mt={0.5}>
              Choose a city from the dropdown and save it
            </ArgonTypography>
          </ArgonBox>

          {/* Body */}
          <CardContent>
            <form>
              <Grid container spacing={3}>
                {/* City Select */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography
                    variant="subtitle2"
                    fontWeight="medium"
                    color="text"
                    mb={1}
                  >
                    Enter City
                  </ArgonTypography>
                  <ArgonInput
                  placeholder="Enter City"
                  fullWidth
                  />
                  
                </Grid>
              </Grid>

              {/* Footer Buttons */}
              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={4}>
                <ArgonButton
                  variant="outlined"
                  color="secondary"
                  href="/admin/state"
                  sx={{ borderRadius: "12px", px: 3 }}
                >
                  Cancel
                </ArgonButton>
                <ArgonButton
                  type="submit"
                  variant="gradient"
                  color="info"
                  sx={{
                    borderRadius: "12px",
                    px: 4,
                    fontWeight: "bold",
                    boxShadow: "0px 4px 12px rgba(8,2,120,0.4)",
                  }}
                >
                  Save
                </ArgonButton>
              </ArgonBox>
            </form>
          </CardContent>
        </Card>
      </ArgonBox>
    </ArgonBox>

      <Footer />
    </DashboardLayout>


  )
}

export default AddTutor